export const MENU_OPTION_TYPES = {
  OPTION: 'option',
  SECTION: 'section',
  SEPARATOR: 'separator',
} as const;

export const INTERNAL_MENU_OPTION_TYPES = {
  CREATABLE: 'creatable',
} as const;

export const MENU_CONTROL_REASONS = {
  SELECT_OPTION: 'selectOption',
  CLOSE: 'close',
  OPEN: 'open',
  BLUR: 'blur',
};
